const consultar_estatistica_solicitacao = [
  {
    path: "/consulta-estatistica-solicitacao",
    redirect: "",
    meta: {
      breadCrumb: "Gestão - Emissão de Documentos",
    },
    children: [
      {
        path: "/consulta-estatistica-solicitacao",
        name: "consulta-estatistica-solicitacao",
        component: () =>
          import(
            "@/views/ConsultarEstatisticaSolicitacao/ConsultarEstatisticaSolicitacaoHome.vue"
          ),
      },
    ],
  },
];

export { consultar_estatistica_solicitacao };
